import { useContext } from 'react';

import { PermissionsContext } from './Permissions';

export default function usePermissions() {
  const values = useContext(PermissionsContext);
  return values;
}
